module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./~/mqtt/~/readable-stream/lib/internal/streams/from-browser.js
// module id = 258
// module chunks = 73